import Color from 'color';

export const getButtonGradiant = (primary: string): string => `linear-gradient(90deg,
 ${Color(primary)
    .lighten(0.7)
    .desaturate(0.4)
    .hex()}
    0%,
${Color(primary)
    .saturate(0.1)
    .darken(0.05)
    .hex()}
    21.93%,
${Color(primary)
    .lighten(0.15)
    .hex()} 
    52.35%,
${Color(primary)
    .lighten(0.2)
    .saturate(0.05)
    .rotate(2)
    .hex()} 77.8%, 
${Color(primary)
    .saturate(0.15)
    .darken(0.05)
    .hex()}
    100%)`;
